var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('UserRow',{attrs:{"msg":"Welcome to ROA User App !!"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }